import React from 'react'
import styled from 'styled-components'

import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Text = styled(Paragraph)`
  margin-bottom: 48px;
`

const ImageItem = styled.div`
  max-width: 370px;
  img {
    width: 100%;
  }
  :not(:last-child) {
    margin-bottom: 32px;
  }
`

const Images = () => {
  return (
    <>
      <Heading>Images</Heading>
      <Text>We mostly use two aspect ratios for our imagery; 3:2 and 1:1. We use 2:1 for customer logos.</Text>
      <ImageItem>
        <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />
      </ImageItem>
      <ImageItem>
        <img src="/images/chameleon/fixed-aspect-ratio-spacer-1.png" alt="" />
      </ImageItem>
      <ImageItem>
        <img src="/images/chameleon/fixed-aspect-ratio-spacer-2.png" alt="" />
      </ImageItem>
    </>
  )
}

export default Images
